export default "__VITE_ASSET__DD7y3B2U__"